import { render } from "./pinpaiyichang.vue?vue&type=template&id=8b9746b2&scoped=true"
import script from "./pinpaiyichang.vue?vue&type=script&lang=js"
export * from "./pinpaiyichang.vue?vue&type=script&lang=js"

import "./pinpaiyichang.vue?vue&type=style&index=0&id=8b9746b2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8b9746b2"

export default script